"use strict";

// Selectize
let selectSearch = $('.SelectSearch').selectize({
  placeholder: "Начните вводить текст",
  readOnly: true,
  openOnFocus: false,
  onInitialize: function onInitialize() {
    var that = this;
    this.$control.on("click", function () {
      that.ignoreFocusOpen = true;
      setTimeout(function () {
        that.ignoreFocusOpen = false;
      }, 50);
    });
  },
  onFocus: function onFocus() {
    if (!this.ignoreFocusOpen) {
      this.open();
    }
  },
  onChange: function(value) {
    var name = this.$input.attr('name');
    var $item = this.$input.closest('.ObjectFilter_item');
    console.log('change')

    if ($item.index() == 0) {
      $item.next().next().addClass('Disable');
    }

    if (value !== '') {
      $item.next().removeClass('Disable');

    } else {
      $item.next().addClass('Disable');
    }

    if ( name == "subject_rf" ) {
        var select = $("#district")[0].selectize;
        select.clear(true);
        select.clearOptions();

        for( var ii = 0; ii < region_list.length; ii++ )
            if ( region_list[ ii ][ 'PARENT_SUBJECT' ] == value ) {
                select.addOption({ value: region_list[ ii ][ 'ID' ], text: region_list[ ii ][ 'NAME' ]})
            }
    } else
    if ( name == "district" ) {
        var select = $("#highway")[0].selectize;
        select.clear(true);
        select.clearOptions();

        for( var ii = 0; ii < highway_list.length; ii++ ) {
            console.log( highway_list[ii]  );
            if ( highway_list[ii]['PARENT_REGION'] )
                if (highway_list[ii]['PARENT_REGION'].indexOf(value) >= 0) {
                    select.addOption({value: highway_list[ii]['ID'], text: highway_list[ii]['NAME']})
                }
        }
    }
  },
});

$(document).ready(() => {
  let $selects = $('.FilterBlock').find('.selectize-input');

  $selects.each((i, e) => {
    if (i !== 0 && !$(e).hasClass('full')) {
      $(e).closest('.ObjectFilter_item').addClass('Disable');
    }
  });
})
let selectBtn = $('.Select').selectize({
  create: false,
  persist: false,
  maxItems: 1,
  openOnFocus: false,
  onInitialize: function onInitialize() {
    var that = this;
    this.$control.on("click", function () {
      that.ignoreFocusOpen = true;
      setTimeout(function () {
        that.ignoreFocusOpen = false;
      }, 50);
    });
  },
  onFocus: function onFocus() {
    if (!this.ignoreFocusOpen) {
      this.open();
    }
  }
});
$(".Select .selectize-input input").attr('readonly', 'readonly'); // Range sliders

var LandArea = $("#LandArea");

var minamax = LandArea.data("minamax").split("-");
var v_values = LandArea.data("values").split("-");
minamax[ 0 ] = parseInt( minamax[ 0 ] );
minamax[ 1 ] = parseInt( minamax[ 1 ] );
v_values[ 0 ] = parseInt( v_values[ 0 ] );
v_values[ 1 ] = parseInt( v_values[ 1 ] );

var LandAreaOptions = {
  range: true,
  min: minamax[ 0 ],
  max: minamax[ 1 ],
  values: v_values, //[12, 7700],
  classes: {
    "ui-slider-handle": "RangeSlider_handle",
    "ui-slider-range": "RangeSlider_range"
  },
  slide: function slide(event, ui) {
    $('#LandAreaMin').text(ui.values[0] + " сот.");
    $('#LandAreaMax').text(ui.values[1] / 100 + " Га");

    $('#LandAreaMin_hid').val( ui.values[0] );
      $('#LandAreaMax_hid').val( ui.values[1] );
  }
};

LandArea.slider(LandAreaOptions);

var AreaCost = $("#AreaCost");

var AreaCost_minamax = AreaCost.data("minamax").split("-");
var AreaCost_v_values = AreaCost.data("values").split("-");
AreaCost_minamax[ 0 ] = parseInt( AreaCost_minamax[ 0 ] );
AreaCost_minamax[ 1 ] = parseInt( AreaCost_minamax[ 1 ] );
AreaCost_v_values[ 0 ] = parseInt( AreaCost_v_values[ 0 ] );
AreaCost_v_values[ 1 ] = parseInt( AreaCost_v_values[ 1 ] );

var AreaCostOptions = {
  range: true,
  min: AreaCost_minamax[ 0 ],
  max: AreaCost_minamax[ 1 ],
  values: AreaCost_v_values,
  classes: {
    "ui-slider-handle": "RangeSlider_handle",
    "ui-slider-range": "RangeSlider_range"
  },
  slide: function slide(event, ui) {
    $('#AreaCostMin').text(ui.values[0].toLocaleString());
    $('#AreaCostMax').text(ui.values[1].toLocaleString());

      $('#AreaCostMin_hid').val( ui.values[0] );
      $('#AreaCostMax_hid').val( ui.values[1] );
  }
};

AreaCost.slider(AreaCostOptions); // Object display type

$('.ObjectDisplayType_label').click(function (event) {
  var labelId = $(this).attr('id'),
      searchResultsMap = $(this).parents('.SearchResults').find('.SearchResults_map'),
      searchResultsList = $(this).parents('.SearchResults').find('.SearchResults_list');
  $(this).siblings('.ObjectDisplayType_label').removeClass('ObjectDisplayType_label-active');
  $(this).addClass('ObjectDisplayType_label-active');

  if (labelId == 'ObjectDisplayAsList') {
    $('.ObjectDisplayType_switch').prop('checked', false);
    searchResultsMap.hide();
    searchResultsList.show();
  } else if (labelId == 'ObjectDisplayOnMap') {
    $('.ObjectDisplayType_switch').prop('checked', true);
    searchResultsMap.show();
    searchResultsList.hide();
    $('.ObjectFilter_searchBtn').trigger('click');
  }

  event.preventDefault();
});
$('.ObjectDisplayType_switch').click(function (event) {
  var searchResultsMap = $(this).parents('.SearchResults').find('.SearchResults_map'),
      searchResultsList = $(this).parents('.SearchResults').find('.SearchResults_list');
  $(this).siblings('.ObjectDisplayType_label').toggleClass('ObjectDisplayType_label-active');

  if ($(this).siblings('.ObjectDisplayType_label-active').attr('id') == 'ObjectDisplayAsList') {
    searchResultsMap.hide();
    searchResultsList.show();
  } else {
    searchResultsMap.show();
    searchResultsList.hide();
    $('.ObjectFilter_searchBtn').trigger('click');
  }
});
$('.ShowOnMap').click(function (event) {
  var searchResultsMap = $(this).parents('.SearchResults').find('.SearchResults_map'),
      searchResultsList = $(this).parents('.SearchResults').find('.SearchResults_list');
  $('.ObjectDisplayType_switch').prop('checked', true);
  $('.ObjectDisplayType_switch').siblings('.ObjectDisplayType_label').toggleClass('ObjectDisplayType_label-active');
  searchResultsMap.show();
  searchResultsList.hide();
  event.preventDefault();
}); // Yandex Map

ymaps.ready(init);
var myMap;
var pointCollection;

function init() {
  myMap = new ymaps.Map("map", {
    center: [55.7780, 37.2328],
    zoom: 16
  });

  myMap.controls.remove('geolocationControl');
  myMap.controls.remove('searchControl');
  myMap.controls.remove('trafficControl');
  myMap.controls.remove('typeSelector');
  myMap.controls.remove('fullscreenControl');
  myMap.controls.remove('rulerControl');
  myMap.behaviors.disable(['scrollZoom']);

  pointCollection = new ymaps.GeoObjectCollection({
      // Чтобы метки начали кластеризоваться, выставляем опцию.
      clusterize: true,
      geoObjectOpenBalloonOnClick: false,
      clusterOpenBalloonOnClick: false
  });

  //pointCollection.objects.options.set('preset', 'islands#greenDotIcon');
  //pointCollection.clusters.options.set('preset', 'islands#greenClusterIcons');
  myMap.geoObjects.add(pointCollection);

    $("#filter_form").submit();
} // Toggle map overlay


$('.MapSection_overlayToggle').click(function (event) {
  var mapSection = $(this).parents('.MapSection');
  mapSection.find('.MapSection_overlayToggle').toggleClass('MapSection_overlayToggle-close');
  mapSection.find('.MapSection_overlay').fadeToggle();
}); // Sorting objects

$('.SortingObjects_link').click(function (event) {
  event.preventDefault();

  let $item = $(this).parent();

  $item.siblings().removeClass('SortingObjects_item-active').removeClass('SortingObjects_item-activeBottom');

  if ($item.hasClass('SortingObjects_item-active')) {
    $item.removeClass('SortingObjects_item-active');
    $item.addClass('SortingObjects_item-activeBottom');
  }

  else if ($item.hasClass('SortingObjects_item-activeBottom')) {
    $item.removeClass('SortingObjects_item-activeBottom');
  }

  else {
    $item.addClass('SortingObjects_item-active')
  }
}); // Fancybox


$('.PopupBetterConditionsLink').fancybox({
  touch: false,
  slideClass: "FancyboxSlide FancyboxSlide-html",
  baseTpl: '<div class="fancybox-container" role="dialog" tabindex="-1">' + '<div class="fancybox-bg FancyboxBg"></div>' + '<div class="fancybox-inner">' + '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' + '<div class="fancybox-toolbar">{{buttons}}</div>' + '<div class="fancybox-navigation">{{arrows}}</div>' + '<div class="fancybox-stage"></div>' + '<div class="fancybox-caption"></div>' + "</div>" + "</div>",
  btnTpl: {
    // This small close button will be appended to your html/inline/ajax content by default,
    // if "smallBtn" option is not set to false
    smallBtn: '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small FancyboxButton" title="{{CLOSE}}">' + '<svg class="SvgIco" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><g class="SvgIco_path" fill="#FFF"><rect width="22" height="2" x="-2" y="8" rx="1" transform="rotate(-45 9 9)"/><rect width="22" height="2" x="-2" y="8" rx="1" transform="rotate(45 9 9)"/></g></svg>' + "</button>"
  },
  lang: "ru",
  i18n: {
    ru: {
      CLOSE: "Закрыть"
    }
  },
    'beforeLoad': function(){
      console.log("beforeLoad...");
        //$(this.element).addClass("visited");
    },
  // beforeLoad: function beforeLoad(instance, current) {
  //     console.log( $(this).html() );
  //     console.log( instance );
  //     console.log( current );
  // },
  afterLoad: function afterLoad(instance, current) {  console.log("afterLoad..."); console.log( $(this).html() ); alert("123");
    $('.Wrapper').addClass('Blur');
  },
  beforeClose: function beforeClose(instance, current) {
    $('.Wrapper').removeClass('Blur');
  }
});
var formGetBetterConditions = new InteractiveForm('.Form-getBetterConditions');


var NumPage = 1;

function frmObjectFilterInit() {
    $("#filter_form").submit(function(){  console.log("frm submit");
        var sdata = $(this).serialize();
        var sdataO = $(this).serializeObject();

        if ( sdataO["NumPage"] == 1 ) {
            $(".SearchResults_body, .Pagination_list").html( "" );
            pointCollection.removeAll();
        }


        window.history.pushState("", "", "?" + sdata );

        $.post( $(this).attr("action"), sdata + "&action=olist&ajax=1", function(res){

            var txt = '';
            var res_json = JSON.parse( res );
            if ( res_json.rowcnt )
                $(".SearchResults_cnt").html( res_json.rowcnt );
            
            if ( res_json.map ) {
              $(res_json.map.list).each(function (index, itemArr) {
                var pos_a = itemArr.map_pos.split(",");
                pointCollection.add(new ymaps.Placemark([pos_a[0], pos_a[1]], {
                    balloonContent: itemArr.id + ', ' + itemArr.location  + "<br><br>" + '<a target="_blank" href="' + itemArr.link + '">Подробнее</a>',
                    iconCaption: itemArr.name,
                    id: itemArr.id
                }, {
                    preset: 'islands#redDotIcon'
                }));
              })
            }

            if ( NumPage > res_json.NavPageCount ) {
                $(".SearchResults_moreLink").hide();
            }


            if ( res_json.list )
            console.log(res_json, 'list')
            $(res_json.list).each(function(index, itemArr){ 

                var img_h = '';

                var icon_svg = ''; // '<svg class="SvgIco" xmlns="http://www.w3.org/2000/svg" width="16" height="21"><g class="SvgIco_fillGroup" fill="#FFF" fill-rule="evenodd"><path d="M9 13.18V21l7-5.18V8zm-9 2.64L7 21v-7.82L0 8z"/><path fill-rule="nonzero" d="M13 5A5 5 0 1 0 3 5a5 5 0 0 0 10 0zM8 7.16A2.16 2.16 0 1 1 10.157 5a2.158 2.158 0 0 1-2.164 2.164L8 7.161z"/></g></svg>';
                if ( itemArr.building_type == 'agriculture' ) {
                    icon_svg = '<svg class="SvgIco" xmlns="http://www.w3.org/2000/svg" width="16" height="21"><g class="SvgIco_fillGroup" fill="#FFF" fill-rule="evenodd"><path d="M9 13.18V21l7-5.18V8zm-9 2.64L7 21v-7.82L0 8z"/><path fill-rule="nonzero" d="M13 5A5 5 0 1 0 3 5a5 5 0 0 0 10 0zM8 7.16A2.16 2.16 0 1 1 10.157 5a2.158 2.158 0 0 1-2.164 2.164L8 7.161z"/></g></svg>';
                } else
                if ( itemArr.building_type == 'individual_housing' ) {
                    icon_svg = '<svg class="SvgIco" xmlns="http://www.w3.org/2000/svg" width="17" height="21"><path class="SvgIco_path" fill="#FFF" d="M8.5 0L0 8.218h1.822V21h13.356V8.218H17L8.5 0zm1.871 15.675h-3.74v-3.617h3.74v3.617z"/></svg>';
                } else
                if ( itemArr.building_type == 'apartment_house' ) {
                    icon_svg = '<svg class="SvgIco" xmlns="http://www.w3.org/2000/svg" width="13" height="22"><path class="SvgIco_path" fill="#FFF" d="M0 0v22h13V0H0zm5.579 18.54H1.943v-3.858h3.636v3.858zm0-5.605H1.943V9.078h3.636v3.857zm0-5.604H1.943V3.468h3.636V7.33zm5.478 11.21H7.421v-3.858h3.636v3.858zm0-5.605H7.421V9.08h3.636v3.857zm0-5.604H7.421V3.468h3.636v3.864z"/></svg>';
                } else
                if ( itemArr.building_type == 'commercial_or_industrial' ) {
                    icon_svg = '<svg class="SvgIco" xmlns="http://www.w3.org/2000/svg" width="16" height="21"><path class="SvgIco_path" fill="#FFF" fill-rule="evenodd" d="M10.5 15.752V10.14l-5.43 5.54L3.99 0H1.152L0 21h16V10.14z"/></svg>';
                } else
                if ( itemArr.building_type == 'recreation_objects' ) {
                    icon_svg = '<svg class="SvgIco" xmlns="http://www.w3.org/2000/svg" width="17" height="23"><path class="SvgIco_path" fill="#FFF" fill-rule="evenodd" d="M17 23l-4.63-8.117h2.407l-3.995-7.005h2.207L8.5 0 4.011 7.878h2.207l-3.995 7.005H4.63L0 23z"/></svg>';
                }

                if ( itemArr.img ) {
                    img_h =
                    '        <div class="ProportionalImage ProportionalImage-objectCard" style="background-image: url(' + itemArr.img + ')"></div> ' +
                    '        <div class="ObjectCard_icon">'+ icon_svg +'</div> ';
                }

                txt +=
                    '<div class="ObjectCard SearchResults_item"><a class="ObjectCard_link" href="'+ itemArr.link +'"></a> ' +
                    '    <div class="ObjectCard_img"> ' +
                    img_h +
                    '    </div> ' +
                    '    <div class="ObjectCard_body"> ' +
                    '        <div class="ObjectCard_text"> ' +
                    '            <div class="ObjectCard_id-and-square"> ' +
                    '                <div class="ObjectCard_id"><span class="ObjectCard_label hidden-smPlus">ID:</span> '+ itemArr.id +'</div> ' +
                    '                <div class="ObjectCard_square hidden-smPlus"><span class="ObjectCard_label hidden-smPlus">Площадь:</span> '+ (itemArr.square / 100) +'</div> ' +
                    '            </div> ' +
                    '            <div class="ObjectCard_location">'+ itemArr.name +'</div> ' +
                    '            <div class="ObjectCard_square hidden-xs">'+ (itemArr.square / 100) +' <span class="ObjectCard_label hidden-smPlus">Га</span></div> ' +
                    '            <div class="ObjectCard_cost"><span class="ObjectCard_label hidden-smPlus">Стоимость:</span> '+ itemArr.price +'</div> ' +
                    '            <div class="ObjectCard_specialPrice"><span class="ObjectCard_label hidden-smPlus">Спец. цена:</span> '+ itemArr.spec_price +'</div> ' +
                    '        </div> ' +
                    '        <div class="ObjectCard_links"> ' +
                    '            <div class="ObjectCard_mapLinkWrap"><a class="Link Link-blue ShowOnMap" href="' + itemArr.link + '">Показать на карте</a></div><a class="BtnDefault BtnDefault-objectCard ObjectCard_btn PopupBetterConditionsLink" href="javascript:;" data-fancybox data-src="#GetBetterConditions" data-flat_id="'+ itemArr.id +'" >Получить лучшие условия</a> ' +
                    '        </div> ' +
                    '    </div> ' +
                    '</div> ';


            });


            $(".SearchResults_body").append( txt );

            $(".Pagination_list").html( res_json.pager_str );

            /* Костыль для первоначальной инициализации яндекс-карты */
            if ( $(".SearchResults_map").attr("style") == "visibility: hidden;" ) {
                $(".SearchResults_map").attr("style", "display: none;")
            }

            $(".Pagination_link").unbind().click(function(){
                NumPage = $(this).data("pn");
                $("#NumPage").val( NumPage );
                $(".SearchResults_body, .Pagination_list").html( "" );

                $("#filter_form").submit();

                return false;
            });

            myMap.setBounds(myMap.geoObjects.getBounds(), {checkZoomRange:true});
        } );


        return false;
    });

    $(".SearchResults_moreLink").click(function(){
        NumPage += 1;
        $("#NumPage").val( $("#NumPage").val() + 1 );

        $("#filter_form").submit();
        return false;
    });

    $(".ObjectFilter_searchBtn").click(function(){
        NumPage = 1;
        $("#NumPage").val( 1 );

        $(".SearchResults_body, .Pagination_list").html("");

        $("#filter_form").submit();
        return false;
    });


    $(".SortingObjects_link").click(function(){
        $("#sort").val( $(this).data("sort") );

        if ( $("#sort").val() == $(this).data("sort") ) {
            $("#sort_order").val( ( ( $("#sort_order").val() == "asc" ) ? "desc" : "asc" ) ) ;

        } else {
            $("#sort_order").val("asc");
        }


        NumPage = 1;
        $("#NumPage").val( 1 );

        $(".SearchResults_body, .Pagination_list").html("");

        $("#filter_form").submit();
        return false;
    });

}


$(document).ready(function(){
    frmObjectFilterInit();
});


function setpoint(selID) {

    var iterator = pointCollection.getIterator(),
        object;
    while ((object = iterator.getNext()) != iterator.STOP_ITERATION)
    if ( object.properties._data.id == selID ){
        console.log( object.properties._data.id );

      console.log( object );

        myMap.setCenter( object.geometry.getCoordinates() );
        myMap.setZoom( 16 );

        $('.ObjectDisplayType_switch').click();

        break;

    }
}

$('[data-objreset]').on('click', function (e) {
  e.preventDefault();

  let checkboxes = $('#filter_form').find('.Checkbox_input');
  let searchBtn = $('#filter_form').find('.ObjectFilter_searchBtn');

  checkboxes.each(function () {
    if ($(this).prop('checked')) {
      $(this).prop('checked', false);
    }
  });

  $(".SearchForm_text").val("");

  AreaCost.slider( "values", 0,  AreaCost_minamax[ 0 ] );
  AreaCost.slider( "values", 1,  AreaCost_minamax[ 1 ] );
  LandArea.slider( "values", 0,  minamax[ 0 ] );
  LandArea.slider( "values", 1,  minamax[ 1 ] );

  $('#AreaCostMin').text(AreaCostOptions.values[0].toLocaleString());
  $('#AreaCostMax').text(AreaCostOptions.values[1].toLocaleString());

  $('#AreaCostMin_hid').val( AreaCostOptions.values[0] );
  $('#AreaCostMax_hid').val( AreaCostOptions.values[1] );


  $('#LandAreaMin').text(LandAreaOptions.values[0] + " сот.");
  $('#LandAreaMax').text(LandAreaOptions.values[1] / 100 + " Га");

  $('#LandAreaMin_hid').val( LandAreaOptions.values[0] );
  $('#LandAreaMax_hid').val( LandAreaOptions.values[1] );

  selectBtn.each(function () {
    let select = $(this)[0].selectize;
    select.clear(true);
  })

  selectSearch.each(function () {
    let select = $(this)[0].selectize;
    select.clear(true);
  })

  searchBtn.trigger('click');

  let $selects = $('.FilterBlock').find('.selectize-input');
  $selects.each((i, e) => {
    if (i !== 0 && !$(e).hasClass('full')) {
      $(e).closest('.ObjectFilter_item').addClass('Disable');
    }

  });
  
});

$(document).ready(() => {
  $('.SearchResults_map').hide();
});